<template>
  <div class="menu-container">
    <!-- 桌面端使用 el-dropdown -->
    <el-dropdown v-for="(item, i) in list" :key="i" :placement="isType" :hide-on-click="false" class="desktop-dropdown"
      v-if="!isMobile">
      <p>{{ item.label }}</p>
      <template #dropdown v-if="!!item?.children">
        <el-dropdown-menu>
          <el-dropdown-item v-for="(items, idx) in item.children" :key="idx">
            <a :href="items.link" target="_blank">
              {{ items.label }}
            </a>
          </el-dropdown-item>
        </el-dropdown-menu>
      </template>
    </el-dropdown>

    <!-- 移动端使用自定义下拉菜单 -->
    <div class="mobile-menu-wrapper" v-if="isMobile">
      <div v-for="(item, i) in list" :key="'mobile-' + i" class="mobile-dropdown" v-click-outside="() => closeMenu(i)"
        :class="{ 'half-width': ['政府网站', '兄弟学会'].includes(item.label) }">
        <p @click="toggleMenu(i)">{{ item.label }}</p>
        <div class="mobile-dropdown-menu" v-show="activeIndex === i && !!item?.children">
          <a v-for="(items, idx) in item.children" :key="idx" :href="items.link" target="_blank"
            class="mobile-dropdown-item">
            {{ items.label }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, onMounted, onUnmounted } from 'vue';

const props = defineProps({
  isType: {
    type: String
  },
  list: {
    type: Array
  }
});

const isMobile = ref(false);
const activeIndex = ref<number | null>(null);

// 检测是否为移动端
const checkMobile = () => {
  isMobile.value = window.innerWidth <= 768;
};

// 切换菜单显示
const toggleMenu = (index: number) => {
  activeIndex.value = activeIndex.value === index ? null : index;
};

// 关闭菜单
const closeMenu = (index: number) => {
  if (activeIndex.value === index) {
    activeIndex.value = null;
  }
};

// 点击外部关闭菜单的自定义指令
const vClickOutside = {
  mounted(el: HTMLElement, binding: any) {
    el.clickOutsideEvent = (event: MouseEvent) => {
      if (!(el === event.target || el.contains(event.target as Node))) {
        binding.value();
      }
    };
    document.addEventListener('click', el.clickOutsideEvent);
  },
  unmounted(el: HTMLElement) {
    document.removeEventListener('click', el.clickOutsideEvent);
  }
};

onMounted(() => {
  checkMobile();
  window.addEventListener('resize', checkMobile);
});

onUnmounted(() => {
  window.removeEventListener('resize', checkMobile);
});
</script>

<style lang="scss" scoped>
.menu-container {
  display: flex;
  gap: 30px;
}

.el-tooltip__trigger:focus-visible {
  outline: none;
}

p {
  font-size: 1vw;
  cursor: pointer;
  margin: 0;
  padding: 8px 12px;
}

a {
  color: #606266;
  font-size: 1vw;
  text-decoration-line: none;
}

a:hover {
  color: #409eff;
}

/* 移动端下拉菜单样式 */
.mobile-menu-wrapper {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  gap: 10px;
}

.mobile-dropdown {
  position: relative;

  &.half-width {
    flex: 1 0 calc(50% - 10px);
    max-width: calc(50% - 10px);
  }

  .mobile-dropdown-menu {
    position: absolute;
    top: 100%;
    left: 0;
    z-index: 1000;
    min-width: 160px;
    background: white;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    padding: 5px 0;

    .mobile-dropdown-item {
      display: block;
      padding: 8px 20px;
      line-height: 1;
      font-size: 14px;
      color: #606266;

      &:hover {
        color: #409eff;
        background-color: #ecf5ff;
      }
    }
  }
}

/* 响应式调整 */
@media (max-width: 768px) {
  .menu-container {
    flex-direction: column;
    gap: 10px;
  }

  p,
  a {
    font-size: 14px !important;
  }

  .desktop-dropdown {
    display: none;
  }

  .mobile-dropdown {
    display: block;
    width: 100%;

    &:not(.half-width) {
      width: 100%;
    }
  }
}

@media (min-width: 769px) {

  .mobile-menu-wrapper,
  .mobile-dropdown {
    display: none;
  }

  .desktop-dropdown {
    display: block;
  }
}
</style>